import React, { useState } from 'react';
import { Feedback } from '../../Feedback';
import { AdsCounter } from '../../AdsCounter';
import { SkipAdButton } from '../../SkipAdButton';
import { HideableContainer } from '../../HideableContainer';
import { FullscreenButton } from '../../FullscreenButton';
import { Volume } from '../../Volume';
import { ProgressBarContainer, ProgressBar, FlexContainer } from '../styled';
import { ClickThrough } from '../../ClickThrough';
import { Center, Footer, FooterButtons, Container } from '../components';
import { AdvertisementPermanentContainer, AdvertisementTimeline, Header } from './styled';
import { PermanentContainer } from '../../PermanentContainer';
export const AdvertisementUI = ({ playerInstance }) => {
    const [isHidden, setIsHidden] = useState(false);
    return (React.createElement("div", null,
        React.createElement(PermanentContainer, { isHidden },
            React.createElement(Header, null),
            React.createElement(Center, null,
                React.createElement(Feedback, { playerInstance })),
            React.createElement(Footer, null,
                React.createElement(AdvertisementPermanentContainer, { isHidden },
                    React.createElement(FlexContainer, null,
                        React.createElement(AdsCounter, { playerInstance })),
                    React.createElement(SkipAdButton, { playerInstance })))),
        React.createElement(HideableContainer, { onShow: () => {
                setIsHidden(false);
            }, onHide: () => {
                setIsHidden(true);
            } },
            React.createElement(Container, null,
                React.createElement(Header, null,
                    React.createElement(ClickThrough, { playerInstance })),
                React.createElement(Center, null),
                React.createElement(Footer, null,
                    React.createElement(ProgressBarContainer, null,
                        React.createElement(ProgressBar, null,
                            React.createElement(AdvertisementTimeline, { playerInstance }))),
                    React.createElement(FooterButtons, null,
                        React.createElement("div", null,
                            React.createElement(Volume, { playerInstance })),
                        React.createElement("div", null,
                            React.createElement(FullscreenButton, { playerInstance }))))))));
};
//# sourceMappingURL=index.js.map